import classNames from 'classnames'
import { Slider } from 'baseui/slider'
import React from 'react'
import { WemoloTypography } from '../Wemolo'
import styles from './SliderSingle.module.css'

type SliderComponentSingleProps = {
    max: number
    setValue: (value: number) => void
    value_view: number
    min?: number
    step?: number
    disabled?: boolean
    persistentThumb?: boolean
    transparentBackground?: boolean
    sliderGuidelines?: boolean
}

export const SliderComponentSingle = ({
    max,
    min = 0,
    step = 1,
    setValue,
    value_view,
    disabled = false,
    persistentThumb = true,
    transparentBackground = false,
    sliderGuidelines = false
}: SliderComponentSingleProps) => {
    // the percentage locations of where you want to have the guide lines on the sliders
    const sliderGuidelineLocations = [0, 25, 50, 75, 100]
    const guidelineColor = disabled ? 'gray' : '#000'

    return (
        <Slider
            value={[value_view]}
            min={min}
            max={max}
            step={step}
            persistentThumb={persistentThumb}
            onChange={({ value }) => {
                if (value !== undefined && value.length >= 0) {
                    setValue(value[0])
                }
            }}
            disabled={disabled}
            overrides={{
                Root: {
                    style: {
                        paddingTop: '5px',
                        backgroundColor: transparentBackground ? 'transparent' : 'rgb(238, 238, 238)',
                        borderRadius: '5px',
                        height: '80px',
                        marginBottom: '0px'
                    }
                },
                Thumb: {
                    style: {
                        zIndex: '3 !important',
                        width: '18px',
                        height: '18px'
                    }
                },
                Tick: {
                    style: {
                        fontSize: '12px'
                    }
                },
                TickBar: {
                    component: () => {
                        if (!sliderGuidelines) {
                            return null
                        }
                        return (
                            <div className={styles.tickBar}>
                                {sliderGuidelineLocations.map((percentage, index) => (
                                    <div
                                        key={index}
                                        className={classNames(
                                            styles.guideline,
                                            index % 2 === 0 ? styles.guidelineEven : styles.guidelineOdd
                                        )}
                                        style={{
                                            left: `${percentage}%`,
                                            backgroundColor: guidelineColor
                                        }}
                                    />
                                ))}
                                <div className={styles.guidelineLabel} style={{ left: '0%', color: guidelineColor }}>
                                    <WemoloTypography variant="label-xsmall" tag="div">
                                        {min}
                                    </WemoloTypography>
                                </div>
                                <div className={styles.guidelineLabel} style={{ left: '25%', color: guidelineColor }}>
                                    <WemoloTypography variant="label-xsmall" tag="div">
                                        {Math.round(max / 4)}
                                    </WemoloTypography>
                                </div>
                                <div className={styles.guidelineLabel} style={{ left: '50%', color: guidelineColor }}>
                                    <WemoloTypography variant="label-xsmall" tag="div">
                                        {Math.round(max / 2)}
                                    </WemoloTypography>
                                </div>
                                <div className={styles.guidelineLabel} style={{ left: '75%', color: guidelineColor }}>
                                    <WemoloTypography variant="label-xsmall" tag="div">
                                        {Math.round((3 * max) / 4)}
                                    </WemoloTypography>
                                </div>
                                <div className={styles.guidelineLabel} style={{ left: '100%', color: guidelineColor }}>
                                    <WemoloTypography variant="label-xsmall" tag="div">
                                        {max}
                                    </WemoloTypography>
                                </div>
                            </div>
                        )
                    }
                },
                InnerThumb: () => null,
                ThumbValue: ({ $value }) => (
                    <WemoloTypography variant="label-xsmall" tag="div" className={styles.thumbValue}>
                        {$value[0]}
                    </WemoloTypography>
                )
            }}
        />
    )
}
